export enum WritingListStatusEnum {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  DELETE = 'DELETE',
  END_SCHEDULE = 'END_SCHEDULE',
  CANCEL_END_SCHEDULE = 'CANCEL_END_SCHEDULE',
}
